import { css } from 'styled-components';

import * as variables from './variables';

const { black } = variables;

export const marginBottomMedium = css`
    margin-bottom: 8rem;
`;

export const boxShadow = css`
    box-shadow: 0 1rem 2rem ${black}33;
`;

export const boxShadowCircle = css`
    box-shadow: 0 1rem 3rem ${black}1a;
`;
